import styled from '@emotion/styled';
export const ProductTagContainer = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${(props) => (props.small ? '30px' : '40px')};
  width: ${(props) => (props.small ? '30px' : '40px')};
`;
